export default "__VITE_PUBLIC_ASSET__b63434c9__"